import { createStore } from "vuex";
import { testData } from "../assets/map/data";

export default createStore({
  state: {
    testData: testData,
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
